<div *ngIf="displayLogs !== null && displayLogs !== ''" id="display-logs" [innerHTML]="displayLogs"></div>

<div *ngIf="hasSmile9IdInLocalstorage | async" id="auto-act-menu">
  <div class="d-flex">
    <div *ngIf="(enableAutoSignIn | async) || (enableAutoSignOut | async)" class="enable-auto-signin-signout">Auto</div>
  </div>
</div>
